import { DEFAULT_LAYER_VALUES } from './layerValues';
import { EMapLayer, TLayerValues } from 'types';
import { EUpwellingDepth } from './types';

/**
 *
 */
export function getDefaultLayerValues(
  layer?: EMapLayer,
  depth = EUpwellingDepth['DEPTH_0']
): Partial<TLayerValues> {
  const values = {};
  if (!layer) return DEFAULT_LAYER_VALUES[EMapLayer.SALINITY] as any;

  // if (!depth) return DEFAULT_LAYER_VALUES[layer];

  Object.entries(DEFAULT_LAYER_VALUES[layer] || {}).forEach(
    ([key, val]: [string, any]) =>
      (values[key] = typeof val === 'function' ? val(depth) : val)
  );

  return values;
}
